import { ArrowRight, LockKeyhole, RadioTower, ShieldCheck } from "lucide-react";
import { API_BASE_URL } from "../lib/api";
import { Brand } from "./Brand";

interface SignInProps {
  reason?: "denied" | "error" | "invalid" | null;
}

const messages = {
  denied: "That WorkOS identity is not on the UpdateRelay administrator allowlist.",
  error: "WorkOS could not complete the sign-in. Try again, then check the API logs if it repeats.",
  invalid: "The sign-in handshake expired or could not be verified. Start a fresh sign-in below.",
};

export function SignIn({ reason }: SignInProps) {
  return (
    <main className="signin-shell">
      <section className="signin-panel">
        <Brand />
        <div className="signin-panel__copy">
          <p className="eyebrow">Private release control</p>
          <h1>Keep every installer on the right signal.</h1>
          <p>
            Publish one canonical answer for each application, channel, platform, and architecture.
          </p>
        </div>
        <div className="signal-illustration" aria-hidden="true">
          <span className="signal-illustration__node signal-illustration__node--one" />
          <span className="signal-illustration__node signal-illustration__node--two" />
          <span className="signal-illustration__node signal-illustration__node--three" />
          <span className="signal-illustration__line signal-illustration__line--one" />
          <span className="signal-illustration__line signal-illustration__line--two" />
          <RadioTower size={32} />
        </div>
      </section>

      <section className="signin-card" aria-labelledby="signin-title">
        <span className="signin-card__icon" aria-hidden="true">
          <LockKeyhole size={22} />
        </span>
        <p className="eyebrow">Management access</p>
        <h2 id="signin-title">Sign in to the relay</h2>
        <p>
          Access is invitation-only. Authentication, session refresh, and account security are
          handled by WorkOS AuthKit.
        </p>
        {reason ? <div className="alert alert--warning">{messages[reason]}</div> : null}
        <button
          className="button button--primary button--wide"
          type="button"
          onClick={() => window.location.assign(`${API_BASE_URL}/v1/auth/login`)}
        >
          Continue with WorkOS <ArrowRight size={17} />
        </button>
        <div className="signin-card__trust">
          <ShieldCheck size={16} aria-hidden="true" />
          <span>Your credentials never pass through the static management site.</span>
        </div>
      </section>
    </main>
  );
}
